module.exports = __webpack_public_path__ + "static/media/4.7c899155.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/Components/Carousel/CarouselMedia/4.jpg
// module id = 165
// module chunks = 0